var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTrading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.207 6.3L21.536 0.320999C20.9817 0.109304 20.3934 0.000523351 19.8 0C19.206 0.00027995 18.617 0.109064 18.062 0.320999L2.389 6.3C1.68653 6.56796 1.082 7.04292 0.655397 7.66202C0.228798 8.28112 0.000250052 9.01516 1.03422e-06 9.767V29.829C-0.000560567 30.5815 0.22761 31.3164 0.654262 31.9363C1.08091 32.5562 1.6859 33.0318 2.389 33.3L18.06 39.275C18.6153 39.4885 19.205 39.5987 19.8 39.6C20.394 39.5997 20.983 39.4909 21.538 39.279L37.207 33.3C37.9109 33.0324 38.5167 32.5571 38.9441 31.9372C39.3715 31.3173 39.6003 30.582 39.6 29.829V9.767C39.5994 9.01469 39.3703 8.2803 38.943 7.66115C38.5156 7.04201 37.9102 6.56732 37.207 6.3V6.3Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.611 16.496L30.94 10.517C30.3857 10.3053 29.7974 10.1966 29.204 10.196C28.6099 10.1963 28.0209 10.3051 27.466 10.517L11.793 16.496C11.0905 16.764 10.486 17.239 10.0594 17.8581C9.63279 18.4772 9.40424 19.2112 9.40399 19.963V40.025C9.40343 40.7776 9.6316 41.5125 10.0583 42.1324C10.4849 42.7523 11.0899 43.2278 11.793 43.496L27.464 49.471C28.0193 49.6846 28.609 49.7947 29.204 49.796C29.798 49.7958 30.387 49.687 30.942 49.475L46.611 43.496C47.3148 43.2285 47.9207 42.7532 48.3481 42.1332C48.7755 41.5133 49.0042 40.778 49.004 40.025V19.963C49.0034 19.2107 48.7743 18.4763 48.347 17.8572C47.9196 17.2381 47.3142 16.7634 46.611 16.496V16.496Z",
    fill: "#AC6AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.06 39.276L9.40401 35.973V19.963C9.40453 19.2113 9.63319 18.4773 10.0598 17.8583C10.4863 17.2392 11.0907 16.7642 11.793 16.496L27.464 10.516C28.5834 10.0894 29.8206 10.0894 30.94 10.516L39.596 13.816V29.826C39.5961 30.5787 39.3674 31.3137 38.9402 31.9334C38.513 32.5532 37.9075 33.0284 37.204 33.296L21.536 39.276C20.4166 39.7027 19.1794 39.7027 18.06 39.276V39.276Z",
    fill: "#72F5FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9814 5.85724L9.64309 13.1956C9.30167 13.5368 9.06911 13.9716 8.97483 14.445C8.88056 14.9183 8.9288 15.4091 9.11347 15.855C9.29844 16.3014 9.61188 16.6828 10.014 16.9507C10.4161 17.2186 10.8888 17.361 11.372 17.3597L14.6119 17.3612L14.6119 25.7828C14.6121 26.4299 14.8693 27.0505 15.3269 27.5081C15.7845 27.9657 16.405 28.2228 17.0522 28.223L19.4924 28.2237C20.1398 28.2237 20.7606 27.9665 21.2184 27.5088C21.6761 27.051 21.9333 26.4302 21.9333 25.7828L21.9326 17.3619L25.1768 17.3619C25.6596 17.3619 26.1315 17.2187 26.5329 16.9505C26.9343 16.6823 27.2472 16.301 27.4319 15.855C27.6167 15.409 27.665 14.9182 27.5709 14.4447C27.4767 13.9712 27.2442 13.5363 26.9029 13.1949L19.568 5.86007C19.2252 5.51718 18.7602 5.32431 18.2753 5.32378C17.7904 5.32325 17.3251 5.5151 16.9814 5.85724V5.85724ZM30.0262 43.7242L37.3588 36.3915C37.7002 36.0501 37.9327 35.6152 38.0268 35.1417C38.121 34.6682 38.0727 34.1774 37.8879 33.7314C37.7032 33.2854 37.3903 32.9042 36.9889 32.6359C36.5875 32.3677 36.1156 32.2246 35.6328 32.2245L32.3872 32.2217L32.3865 23.8008C32.3865 23.1534 32.1293 22.5326 31.6715 22.0748C31.2138 21.617 30.5929 21.3599 29.9455 21.3598L27.5067 21.3606C26.8594 21.3606 26.2385 21.6177 25.7807 22.0755C25.323 22.5333 25.0658 23.1541 25.0658 23.8015L25.0658 32.2217L21.8223 32.2224C21.3395 32.2224 20.8676 32.3656 20.4662 32.6338C20.0648 32.902 19.7519 33.2833 19.5672 33.7293C19.3824 34.1753 19.3341 34.6661 19.4283 35.1396C19.5224 35.6131 19.7549 36.048 20.0963 36.3894L27.4311 43.7242C27.7744 44.0676 28.2402 44.2605 28.7258 44.2605C29.2114 44.2605 29.6771 44.0676 30.0205 43.7242L30.0262 43.7242Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35_276",
    x: 0.927841,
    y: -2.67627,
    width: 45.1459,
    height: 54.9368,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.370833 0 0 0 0 0.262035 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49.792,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrading);
export default __webpack_public_path__ + "static/media/ic_trading.01d86b64a975152e4e3cb8b62a5d5c77.svg";
export { ForwardRef as ReactComponent };